// Tutaj wpisz swój klucz API ImgBB raz na zawsze
export const IMGBB_API_KEY = process.env.REACT_APP_IMGBB_API_KEY;
export const ADMIN_EMAILS = (process.env.REACT_APP_ADMIN_EMAILS || "").split(",");